import state from './budget.state'
import mutations from './budget.mutations'
import actions from './budget.actions'

export default {
  state,
  mutations,
  actions
}
